import { Flex } from 'rebass';
import styled from 'styled-components';
import colors from 'theme/colors';

const BlockWrapper = styled(Flex)`
  border: 2px solid ${colors.darkGray};
  padding: 30px 30px 40px;
  white-space: pre-wrap;
  min-height: 230px;
  max-height: 300px;
  overflow-y: auto;
`;

export default BlockWrapper;
